/* ==========================================================================
   Fuldbooket — bevægelseslag

   Siden var statisk: ét keyframe (marquee) i 1663 linjer CSS og ingen JS.
   Her ligger fire ting, alle drevet af IntersectionObserver, så intet kører
   før det er i billedet, og alt slås fra ved prefers-reduced-motion.

     1. reveal      — sektioner og kort glider ind, forskudt
     2. telefonen   — sms-tråden skrives ud besked for besked med
                      skriveindikator, som en rigtig samtale
     3. transkript  — opkaldets replikker kommer én ad gangen
     4. tal         — beløb tælles op når de rammer skærmen

   Ingen afhængigheder. Alt fejler stille, hvis en node mangler.
   ========================================================================== */
(function () {
  'use strict';

  function each(sel, root, fn) {
    var list = (root || document).querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  /* ------------------------------------------------------------------ header
     Ligger uden for try/catch-blokken nedenfor og har sin egen, fordi
     navigationen skal virke, selv hvis en animation fejler. Uden JS er
     skuffen skjult og undermenuer lukkede, men alle links står i DOM'en
     og virker som almindelige links. */
  try {
    var header = document.querySelector('[data-fb-header]');

    if (header) {
      /* Skygge når der er rullet væk fra toppen. */
      if (header.classList.contains('fb-header--sticky')) {
        var onScroll = function () {
          header.classList.toggle('is-stuck', window.scrollY > 4);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      /* Mobilskuffe. hidden fjernes først, så overgangen kan nå at køre. */
      var burger = header.querySelector('[data-fb-burger]');
      var drawer = header.querySelector('[data-fb-drawer]');

      if (burger && drawer) {
        var closeTimer = null;

        var setDrawer = function (open) {
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
          document.documentElement.style.overflow = open ? 'hidden' : '';
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }

          if (open) {
            drawer.hidden = false;
            requestAnimationFrame(function () { drawer.classList.add('is-open'); });
          } else {
            drawer.classList.remove('is-open');
            closeTimer = setTimeout(function () { drawer.hidden = true; }, 320);
          }
        };

        burger.addEventListener('click', function () {
          setDrawer(burger.getAttribute('aria-expanded') !== 'true');
        });

        /* Klik på baggrunden lukker, klik i panelet gør ikke. */
        drawer.addEventListener('click', function (e) {
          if (e.target === drawer) setDrawer(false);
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
            setDrawer(false);
            burger.focus();
          }
        });
      }

      /* Undermenuer: klik frem for hover, så de også kan nås på touch. */
      each('[data-fb-submenu]', header, function (item) {
        var toggle = item.querySelector('.fb-header__link--toggle');
        if (!toggle) return;

        toggle.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          each('[data-fb-submenu]', header, function (other) {
            other.classList.remove('is-open');
            var t = other.querySelector('.fb-header__link--toggle');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-fb-submenu]')) {
          each('[data-fb-submenu]', header, function (item) {
            item.classList.remove('is-open');
            var t = item.querySelector('.fb-header__link--toggle');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
      });

      /* Annoncebåndet roterer kun, hvis der er mere end én besked. */
      var band = header.querySelector('[data-fb-announce]');
      if (band) {
        var items = band.querySelectorAll('[data-fb-announce-item]');
        if (items.length > 1) {
          var idx = 0;
          var speed = parseInt(band.getAttribute('data-speed'), 10) || 5000;
          setInterval(function () {
            items[idx].classList.remove('is-in');
            idx = (idx + 1) % items.length;
            items[idx].classList.add('is-in');
          }, speed);
        }
      }
    }
  } catch (err) {
    if (window.console && console.warn) console.warn('[fuldbooket] header:', err);
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Uden IntersectionObserver (eller med reduceret bevægelse) skal alt bare
     stå i sin slutposition. Klassen sættes på <html>, så CSS kan aflyse
     start-tilstanden i ét hug i stedet for at vente på JS pr. element. */
  if (reduce || !('IntersectionObserver' in window)) {
    document.documentElement.classList.add('fb-motion-off');
    return;
  }

  /* Klassen sættes med det samme, ellers når siden at blive tegnet uden
     start-tilstanden og blinker, når den bagefter skjules. Til gengæld
     ligger hele opsætningen i try/catch: kaster noget, fjernes klassen
     igen, og siden står fuldt synlig frem for at ende blank. */
  document.documentElement.classList.add('fb-motion-on');

  function bail(err) {
    document.documentElement.classList.remove('fb-motion-on');
    document.documentElement.classList.add('fb-motion-off');
    if (window.console && console.warn) console.warn('[fuldbooket] bevægelse slået fra:', err);
  }



  /* Én observer pr. opgave, så tærsklerne kan være forskellige. */
  function watch(nodes, onEnter, opts) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        onEnter(e.target);
        if (!opts || !opts.repeat) io.unobserve(e.target);
      });
    }, {
      threshold: (opts && opts.threshold) || 0.2,
      rootMargin: (opts && opts.rootMargin) || '0px 0px -8% 0px'
    });
    nodes.forEach(function (n) { io.observe(n); });
    return io;
  }

  try {
    /* ---------------------------------------------------------------- 1. reveal
       Sektionernes indhold markeres her frem for i hver enkelt Liquid-fil, så
       de 14 fb-sektioner ikke skal røres. Rækkefølgen inde i en sektion giver
       forsinkelsen, så et kortgitter falder på plads fra venstre. */
    var revealSel = [
      '.fb-section > .fb-wrap > *',
      '.fb-hero__lead', '.fb-hero__media', '.fb-hero__actions',
      '.fb-grid-3 > *', '.fb-card', '.fb-receipt__row',
      '.fb-compare tbody tr'
    ].join(',');

    var revealed = [];
    each(revealSel, document, function (el) {
      if (el.closest('.fb-phone')) return;          // telefonen har sin egen koreografi
      if (el.hasAttribute('data-fb-reveal')) return;
      el.setAttribute('data-fb-reveal', '');
      revealed.push(el);
    });

    /* Forsinkelsen regnes pr. forælder, ikke globalt, ellers venter sektion 9
       i evigheder på sektion 1. */
    revealed.forEach(function (el) {
      var sibs = el.parentElement ? el.parentElement.children : [el];
      var idx = Array.prototype.indexOf.call(sibs, el);
      el.style.setProperty('--fb-delay', Math.min(idx, 6) * 70 + 'ms');
    });

    watch(revealed, function (el) { el.classList.add('is-in'); }, { threshold: 0.12 });

    /* ------------------------------------------------------------- 2. telefonen
       Sms-tråden findes færdig i DOM'en. Vi skjuler boblerne, og skriver dem
       ud igen med en pause der passer til længden, så det læser som en samtale
       og ikke som en animation. Indgående beskeder får skriveindikator først,
       præcis som i Beskeder. */
    function typingNode() {
      var d = document.createElement('div');
      d.className = 'fb-ios-bubble fb-ios-bubble--in fb-ios-typing';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<span></span><span></span><span></span>';
      return d;
    }

    function playThread(thread) {
      if (thread.dataset.fbPlaying === '1') return;
      thread.dataset.fbPlaying = '1';

      var bubbles = [];
      each('.fb-ios-bubble', thread, function (b) {
        if (!b.classList.contains('fb-ios-typing')) bubbles.push(b);
      });
      if (!bubbles.length) { thread.dataset.fbPlaying = '0'; return; }

      bubbles.forEach(function (b) { b.classList.remove('is-in'); });
      each('.fb-ios-typing', thread, function (t) { t.remove(); });

      var timers = [];
      var t = 260;

      bubbles.forEach(function (bubble, i) {
        var incoming = bubble.classList.contains('fb-ios-bubble--in');
        /* Læsetid frem for fast interval: lange svar skal føles som lange svar. */
        var chars = (bubble.textContent || '').trim().length;
        var think = incoming ? Math.min(1500, 500 + chars * 7) : 420;

        if (incoming) {
          timers.push(setTimeout(function () {
            var dots = typingNode();
            bubble.parentNode.insertBefore(dots, bubble);
            requestAnimationFrame(function () { dots.classList.add('is-in'); });
            scrollThread(thread);
          }, t));
          t += think;
          timers.push(setTimeout(function () {
            each('.fb-ios-typing', thread, function (d) { d.remove(); });
            bubble.classList.add('is-in');
            scrollThread(thread);
          }, t));
        } else {
          t += think;
          timers.push(setTimeout(function () {
            bubble.classList.add('is-in');
            scrollThread(thread);
          }, t));
        }
        t += 340;

        if (i === bubbles.length - 1) {
          timers.push(setTimeout(function () { thread.dataset.fbPlaying = '0'; }, t + 200));
        }
      });

      thread._fbTimers = timers;
    }

    function scrollThread(el) {
      /* Tråden er kortere end telefonen, så den skal kun rulle når den er fuld. */
      if (el.scrollHeight > el.clientHeight + 4) el.scrollTop = el.scrollHeight;
    }

    var threads = [];
    each('.fb-ios-thread', document, function (el) { threads.push(el); });
    if (threads.length) {
      threads.forEach(function (el) { el.classList.add('fb-thread--anim'); });
      watch(threads, playThread, { threshold: 0.45, repeat: true });
    }

    /* ------------------------------------------------------------ 3. transkript
       Opkaldsskærmen er en liste af replikker. Samme idé, uden skriveindikator,
       fordi det er tale og ikke sms. */
    var transcripts = [];
    each('.fb-ios-transcript', document, function (el) { transcripts.push(el); });

    transcripts.forEach(function (el) { el.classList.add('fb-transcript--anim'); });
    watch(transcripts, function (el) {
      if (el.dataset.fbPlaying === '1') return;
      el.dataset.fbPlaying = '1';
      var lines = el.querySelectorAll('p');
      for (var i = 0; i < lines.length; i++) {
        (function (line, idx) {
          setTimeout(function () {
            line.classList.add('is-in');
            if (idx === lines.length - 1) el.dataset.fbPlaying = '0';
          }, 300 + idx * 620);
        })(lines[i], i);
      }
    }, { threshold: 0.45, repeat: true });

    /* -------------------------------------------------------------------- 4. tal
       Beløbene står som færdig tekst ("= 24.000 kr."). Vi finder det første
       tal, tæller op til det, og lægger teksten tilbage med dansk
       tusindtalsseparator, så markup og oversættelse er uberørt. */
    function countUp(el) {
      if (el.dataset.fbCounted === '1') return;
      var raw = el.textContent;
      var m = raw.match(/(\d[\d.]*)/);
      if (!m) return;

      var target = parseInt(m[1].replace(/\./g, ''), 10);
      if (!isFinite(target) || target < 100) return;   // små tal ser fjollede ud i optælling

      el.dataset.fbCounted = '1';
      var before = raw.slice(0, m.index);
      var after = raw.slice(m.index + m[1].length);
      var dur = 900;
      var start = null;

      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        var now = Math.round(target * eased);
        el.textContent = before + now.toLocaleString('da-DK') + after;
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = raw;                     // slut altid på den rigtige streng
      }
      requestAnimationFrame(frame);
    }

    var sums = [];
    each('.fb-roi__sum, .fb-receipt__total', document, function (el) { sums.push(el); });
    if (sums.length) watch(sums, countUp, { threshold: 0.6 });

  } catch (err) {
    bail(err);
  }
})();
